export default new class LazyImage {
    /** <img
           class="lazy"
           src="image/image-400.jpg"
           data-src="image/image-1400.jpg"
           data-srcset="image/image-400.jpg 400w, image/image-700.jpg 700w, image/image-1400.jpg 1400w"
           alt="ALT image!"
     > */
    init(){
        let lazyImages = [].slice.call(document.querySelectorAll("img.js-lazy-image"));
        lazyImages.push(...document.querySelectorAll("source.lazy"))
        if ("IntersectionObserver" in window) {
            let lazyImageObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        lazyImage.classList.add('js-lazy-image--active');
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove("js-lazy-image");
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            },
            {
                rootMargin: "200px",
            });

            lazyImages.forEach(lazyImage => {
                lazyImageObserver.observe(lazyImage);
            });
        }
    }
}